import { Component } from '@angular/core';
import { BreadcrumbComponent } from 'src/app/common/breadcrumb/breadcrumb.component';

/** simple page layout component */
@Component( {
    selector: 'riege-simple-page',
    templateUrl: './simple-page.component.html',
    styleUrls: ['./simple-page.component.scss'],
    standalone: true,
    imports: [BreadcrumbComponent]
} )
export class SimplePageComponent {
}
